import React, {Component} from "react";
import Input from "../../../components/textbox/Input";
import Button from "../../../components/button/Button";
import {withTranslation} from "react-i18next";
import Calendar from "../../../components/calendar/Calendar";
import Autocomplete from "../../../components/autocomplete/Autocomplete";
import Utils from "../../../utils/Utils";
import Select from "../../../components/select/Select";
import styles from "./FilterForm.module.css"
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";


class FilterForm extends Component {

    state = {
        boxes: [],
    }

    constructor(props) {
        super(props);
        this.createFilters = this.createFilters.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.pulisciTutto = this.pulisciTutto.bind(this)
        this.onClickApplicaFiltri = this.onClickApplicaFiltri.bind(this)
    }

    componentDidMount() {
        sessionStorage.setItem("pathProvenienza", "/" + this.props.pathProvenienza.value)
        this.createFilters()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        sessionStorage.setItem("pathProvenienza", "/" + this.props.pathProvenienza.value)
        if (prevProps != this.props) {
            this.createFilters()
        }
    }

    riceviValore(field, event) {
        let stato = this.props.filtri.stato
        stato[field] = event.target.value
        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})
        this.createFilters()
    }

    pulisciTutto() {
        let stato = this.props.filtri.stato
        let rows = this.props.filtri.rows
        for (let key in stato) {
            for (let i = 0; i < rows.length; i++) {
                if (rows[i][key] && key === rows[i][key].id && !rows[i][key].disabled) {
                    stato[key] = ""
                }
            }
        }
        this.props.filtri.setStatePadre({filtri: stato})
        sessionStorage.removeItem("filtriMonitoraggio")
        this.createFilters()
        this.props.filtri.applicaFiltri(stato)
    }

    createFilters() {
        let boxes = []
        let rows = this.props.filtri.rows
        let row = {}
        let col1 = {}
        let col2 = {}
        let col3 = {}
        const {t} = this.props
        if (rows) {
            for (let i = 0; i < rows.length; i++) {
                for (let key in rows[i]) {
                    let filtro = (
                        rows[i][key].tipo === "input" ?
                            <Input id={rows[i][key].id} field={rows[i][key].field} onChange={this.riceviValore}
                                   value={this.props.filtri.stato[rows[i][key].field]}
                                   placeholder={t(rows[i][key].text)}
                            /> :
                            rows[i][key].tipo === "autocomplete" ?
                                <Autocomplete id={rows[i][key].id} onChange={this.riceviValore}
                                              field={rows[i][key].field}
                                              keyField={rows[i][key].keyField}
                                              disabled={rows[i][key].disabled}
                                              descriptionField={rows[i][key].descriptionField}
                                              suggestionField={rows[i][key].suggestionField}
                                              value={this.props.filtri.stato[rows[i][key].field]}
                                              placeholder={t(rows[i][key].text)}
                                              suggestions={rows[i][key].suggestions}/>
                                :
                                rows[i][key].tipo === "selectAutocomplete" ?
                                    <SelectAutocomplete
                                        id={rows[i][key].id}
                                        onChange={this.riceviValore}
                                        newSelect={true}
                                        field={rows[i][key].field}
                                        value={this.props.filtri.stato[rows[i][key].field]}
                                        functionMap={Utils.mapToArray(rows[i][key].suggestions).map((oggetto) => {
                                            return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}
                                        disabled={rows[i][key].disabled}
                                    />

                                    :
                                    rows[i][key].tipo === "select" ?
                                        <Select
                                            old={true}
                                            value={this.props.filtri.stato[rows[i][key].field]}
                                            field={rows[i][key].field}
                                            id={rows[i][key].id}
                                            newSelect={true}
                                            defaultSelect={rows[i][key].defaultSelect}
                                            onChange={this.riceviValore}
                                            functionMap={Utils.mapToArray(rows[i][key].suggestions).map((oggetto) => {
                                                let option =
                                                    oggetto.cssClass && oggetto.cssClass === "stickerSkyblue" ?
                                                        <option
                                                            value={oggetto.codice}>{oggetto.descrizione} &#128309;</option> :
                                                        oggetto.cssClass && oggetto.cssClass === "stickerYellow" ?
                                                            <option
                                                                value={oggetto.codice}>{oggetto.descrizione} &#128993;</option> :
                                                            oggetto.cssClass && oggetto.cssClass === "stickerGreen" ?
                                                                <option
                                                                    value={oggetto.codice}>{oggetto.descrizione} &#128994;</option> :
                                                                oggetto.cssClass && oggetto.cssClass === "stickerGrey" ?
                                                                <option
                                                                    value={oggetto.codice}>{oggetto.descrizione} &#128280;</option> :
                                                                oggetto.cssClass && oggetto.cssClass === "trattino" ?
                                                                    <option
                                                                        value={oggetto.codice}>{oggetto.descrizione} &#9866;</option> :
                                                                    <option
                                                                        value={oggetto.codice}>{oggetto.descrizione}</option>
                                                return (option)
                                            })}
                                        /> :
                                        rows[i][key].tipo === "data" ?
                                            <Calendar id={rows[i][key].id}
                                                      value={this.props.filtri.stato[rows[i][key].field]}
                                                      field={rows[i][key].field}
                                                      onChange={this.riceviValore}
                                                      newCalendar={true}
                                                      placeholder={rows[i][key].placeholder ? rows[i][key].placeholder : ""}
                                                      errorMessage={this.props.filtri.stato[rows[i][key].field] && Utils.isDateInValid(this.props.filtri.stato[rows[i][key].field]) ? "Data non valida" : ""}
                                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.props.filtri.stato[rows[i][key].field]), "-") &&
                                                      this.props.filtri.stato[rows[i][key].field] !== ""}
                                            /> : <div></div>
                    )
                    if (rows[i][key].numeroCol === 1) {
                        col1 = (
                            <div className={"col-lg-4"}>
                                <div className={styles.fieldContainer}>
                                    {filtro}
                                </div>
                            </div>
                        )
                    } else if (rows[i][key].numeroCol === 2) {
                        col2 = (
                            <div className={"col-lg-4"}>
                                <div className={styles.fieldContainer}>
                                    {filtro}
                                </div>
                            </div>
                        )
                    } else if (rows[i][key].numeroCol === 3) {
                        col3 = (
                            <div className={"col-lg-4"}>
                                <div className={styles.fieldContainer}>
                                    {filtro}
                                </div>
                            </div>
                        )
                    } 
                }
                row = (
                    <div>
                        <div className={"row"} style={{marginTop: "1rem"}}>
                            {Utils.isEmpty(col1) ? <div className={"col-lg-4"}></div> : col1}
                            {Utils.isEmpty(col2) ? <div className={"col-lg-4"}></div> : col2}
                            {Utils.isEmpty(col3) ? <div className={"col-lg-4"}></div> : col3}
                        </div>
                    </div>
                )
                col1 = col2 = col3 = {}
                boxes.splice(i, 0, row)
            }
        }
        // sessionStorage.removeItem("filtriMonitoraggio")
        return this.setState({boxes: boxes})
    }

    onClickApplicaFiltri() {
        let stato = this.props.filtri.stato
        sessionStorage.setItem("filtriMonitoraggio", JSON.stringify(stato))
        this.props.filtri.applicaFiltri(stato)
    }

    render() {
        const {t} = this.props;
        const whiteButton = "btnWhite";
        return (
            <div className={styles.responsive}>
                <div className={"row"} style={{paddingBottom: "1rem"}}>
                    <div className={"col-2"}>
                        <p style={{fontWeight: "bold", fontSize: "22px", marginLeft: "3rem", marginTop: "1rem"}}>Filtra
                            per:</p>
                    </div>
                    <div className={"col-7"}>
                        {this.state.boxes}
                    </div>
                    <div className={"col-3"} style={{marginTop: "3rem"}}>
                        <div className={"row d-flex justify-content-center"}>
                            <div className="mr-1 col-lg-5 ml-1">
                                <Button id={"idButtonApplica"} text={t("Buttons.applica")}
                                        className={[whiteButton, "col-lg-12"].join(" ")}
                                        style={{height: "2rem", fontSize: "15px"}}
                                        onClick={this.onClickApplicaFiltri}
                                />
                            </div>
                            <div className="mr-1 col-lg-5 ml-1">
                                <Button id={"idButtonRimuovi"} text={t("Buttons.rimuovi")}
                                        className={[whiteButton, "col-lg-12"].join(" ")}
                                        style={{height: "2rem", fontSize: "15px"}}
                                        onClick={this.pulisciTutto}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default withTranslation('common')(FilterForm);
